import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppConfig } from 'src/app/app.config';
import { GenericResponse } from 'src/app/entities/various';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FattureAttiveService {

  private invoiceUrl : string =  environment.url;
  //private invoiceUrl: string = AppConfig.settings.apiServer.url;
  public setPageSize: number = 100;

  constructor(private http: HttpClient, private router: Router) { }

  async findInvoice(user_id: number | string, params: HttpParams): Promise<GenericResponse> {
    let response = await this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + user_id + '/invoices', { params: params }).toPromise().then((data: any) => {
      return data;
    }).catch((error) => {
      if (error.status == 403) {
        this.router.navigate(['../Login']);
        return ;
      } else {
        return {success: false, msg: error.message};
      }
    });
    return response;
  }

  async findAllInvoices(user_id: number | string, type: string, params: HttpParams): Promise<GenericResponse> {
    let response = await this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + user_id + '/' + type + '/allinvoices', { params: params }).toPromise().then((data: any) => {
      return data;
    }).catch((error) => {
      if (error.status == 403) {
        this.router.navigate(['../Login']);
        return ;
      } else {
        return {success: false, msg: error.message};
      }
    });
    return response;
  }

  async getDocument(docId: string, userId: any): Promise<GenericResponse> {
    return await this.http.get(this.invoiceUrl + '/api/v1/users/' + userId + '/invoices/' + docId + '/view_alt')
      .toPromise()
      .then((data: any) => {
        return data;
      })
  }

  async getPreviewAr4m(docId: string, userId: any): Promise<GenericResponse> {
    return await this.http.get(this.invoiceUrl + '/api/v1/users/' + userId + '/invoices/' + docId + '/ar4mview')
      .toPromise()
      .then((data: any) => {
        return data;
      })
  }
  
  async getPreviewMinist(invoiceId: string, userId: any): Promise<GenericResponse> {
    let params = new HttpParams();
    params = params.append('complete', true);
    let response = await this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + userId + '/invoices/' +
      invoiceId + '/view', { params: params })
      .toPromise()
      .then((data: any) => {
        return data;
      }).catch((error) => {
        return error;
      });
    return response;
  }

  async downloadZip(userId: any, docsIdArray: string[]): Promise<GenericResponse> {
    let body = { document_ids: docsIdArray };
    return this.http.post(this.invoiceUrl + '/api/v1/users/' + userId + '/invoices/downloadzip', body)
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }

  async downloadPDF(userId: any, docsIdArray: string[], option: string, zip: boolean = true): Promise<GenericResponse> {
    let body = { document_ids: docsIdArray, zipfile: zip };
    return this.http.post(this.invoiceUrl + '/api/v1/users/' + userId + '/invoices/downloadpdf' + option + 'zip', body)
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }

  async downloadInvoiceFiles(userId: any, docId: string, path: string): Promise<GenericResponse> {
    return this.http.get(this.invoiceUrl + '/api/v1/users/' + userId + '/invoices/' + docId + path)
      .toPromise()
      .then((data: any) => {
        return data;
      });

  }

}
